import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createCheckRecoverLoginOutbound } from '../../api/outbound/entryOutbounds';
import { WarningMessageContainer } from '../../components/warningMessageContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { setRecoverLoginStatus } from '../../redux/actions/recoverLoginActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { assertUnreachable } from '../../utils/tsUtils';
import { SubPageContainer } from '../components/subPageContainer';
import { ResetPasswordForm } from './resetPasswordForm';
import { ResetPasswordSuccessContents } from './resetPasswordSuccessContents';
export const RecoverLoginPageContents = () => {
    const { uuid } = useParams();
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const status = useAppSelector((state) => state.recoverLogin.status);
    const player = useAppSelector((state) => state.recoverLogin.validPlayer);
    useEffect(() => {
        if (status !== 'initial') {
            // only check uuid with server if we haven't already gotten a result from it
            return;
        }
        if (uuid) {
            dispatch(setRecoverLoginStatus('checking-uuid'));
            socketSend(createCheckRecoverLoginOutbound(uuid));
        }
        else {
            dispatch(setRecoverLoginStatus('invalid-uuid'));
        }
    }, [dispatch, status, socketSend, uuid]);
    function getContents() {
        switch (status) {
            case 'initial':
            case 'checking-uuid': {
                return _jsx(CircularProgress, { size: 20, color: 'inherit' });
            }
            case 'invalid-uuid': {
                return _jsx(WarningMessageContainer, { message: 'Invalid or Expired Request. Please try recovering your login again.' });
            }
            case 'valid-uuid': {
                if (!uuid || !player) {
                    return null;
                }
                return _jsx(ResetPasswordForm, { uuid: uuid, player: player });
            }
            case 'success': {
                return _jsx(ResetPasswordSuccessContents, {});
            }
            default: {
                assertUnreachable(status);
            }
        }
    }
    return (_jsx(SubPageContainer, { title: 'Recover Login', omitExtraButtons: true, children: getContents() }));
};
